import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Link from './Link';

const LinkDemo = () => {
  return (
    <Container>
      <Container className="mt-10">
        <h4>Links</h4>
        <Row>
          <Col className="mt-10 p-0">
            <Link
              rightIcon={light('arrow-up-right-from-square')}
              onSelect={(selectedKey) => console.log(`selected ${selectedKey}`)}
              eventKey="test"
              isAlignAtEnd
            >
              General links to external site
            </Link>
            <Link rightIcon={light('arrow-up-right-from-square')}>
              General links to external site
            </Link>
            <Link
              rightIcon={light('arrow-up-right-from-square')}
              isAlignAtEnd
              isBlue
            >
              General links to external site
            </Link>
            <Link rightIcon={light('arrow-up-right-from-square')} isBlue>
              General links to external site
            </Link>
            <Link
              rightIcon={light('chevron-right')}
              onSelect={(selectedKey) => console.log(`selected ${selectedKey}`)}
              eventKey="test"
              isAlignAtEnd
            >
              General links to external site
            </Link>
            <Link rightIcon={light('chevron-right')}>
              General links to external site
            </Link>
            <Link rightIcon={light('chevron-right')} isAlignAtEnd isBlue>
              General links to external site
            </Link>
            <Link rightIcon={light('chevron-right')} isBlue>
              General links to external site
            </Link>
            <Link
              leftIcon={light('chevron-right')}
              rightIcon={light('chevron-right')}
              isAlignAtEnd
            >
              General links to external site
            </Link>
            <Link
              leftIcon={light('chevron-right')}
              rightIcon={light('chevron-right')}
            >
              General links to external site
            </Link>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </Container>
  );
};

export default LinkDemo;
